import { CLEAR_LIST_PRODUCT_ACTIVATION_CODE, CREATE_BULK_PRODUCT_ACTIVATION_CODE, CREATE_BULK_PRODUCT_ACTIVATION_CODE_CLEAR, CREATE_BULK_PRODUCT_ACTIVATION_CODE_ERROR, CREATE_BULK_PRODUCT_ACTIVATION_CODE_SUCCESS, CREATE_PRODUCT_ACTIVATION_CODE_CLEAR, EXPORT_CSV_PRODUCT_ACTIVATION_CODE, EXPORT_CSV_PRODUCT_ACTIVATION_CODE_CLEAR, EXPORT_CSV_PRODUCT_ACTIVATION_CODE_ERROR, EXPORT_CSV_PRODUCT_ACTIVATION_CODE_SUCCESS, GET_LIST_PRODUCT_ACTIVATION_CODE, GET_LIST_PRODUCT_ACTIVATION_CODE_ERROR, GET_LIST_PRODUCT_ACTIVATION_CODE_SUCCESS, REMOVE_PRODUCT_ACTIVATION_CODE, REMOVE_PRODUCT_ACTIVATION_CODE_CLEAR, REMOVE_PRODUCT_ACTIVATION_CODE_ERROR, REMOVE_PRODUCT_ACTIVATION_CODE_SUCCESS, UPDATE_PRODUCT_ACTIVATION_CODE_CLEAR } from "./actionTypes";
import { DEFAULT_OFFSET } from "../../../constants/pagination";

const initialState = {
  data: [],
  csvData: '',
  item: null,
  created: null,
  createdBulk: null,
  updated: null,
  removed: null,
  changedStatus: null,
  pagination: { totalCount: 0, nextOffset: DEFAULT_OFFSET },
  error: "",
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_PRODUCT_ACTIVATION_CODE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_LIST_PRODUCT_ACTIVATION_CODE_SUCCESS:
      state = {
        ...state,
        data: action.payload.data,
        pagination: action.payload.pagination,
        loading: false,
      };
      break;
    case GET_LIST_PRODUCT_ACTIVATION_CODE_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case CLEAR_LIST_PRODUCT_ACTIVATION_CODE:
      state = { ...initialState };
      break;
    case UPDATE_PRODUCT_ACTIVATION_CODE_CLEAR:
      state = {
        ...state,
        updated: null,
      };
      break;
    case CREATE_PRODUCT_ACTIVATION_CODE_CLEAR:
      state = {
        ...state,
        created: null,
      };
      break;
    case CREATE_BULK_PRODUCT_ACTIVATION_CODE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CREATE_BULK_PRODUCT_ACTIVATION_CODE_SUCCESS:
      state = {
        ...state,
        createdBulk: action.payload,
        loading: false,
      };
      break;
    case CREATE_BULK_PRODUCT_ACTIVATION_CODE_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case CREATE_BULK_PRODUCT_ACTIVATION_CODE_CLEAR:
      state = {
        ...state,
        createdBulk: null,
      };
      break;
    case REMOVE_PRODUCT_ACTIVATION_CODE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case REMOVE_PRODUCT_ACTIVATION_CODE_SUCCESS:
      state = {
        ...state,
        removed: action.payload,
        loading: false,
      };
      break;
    case REMOVE_PRODUCT_ACTIVATION_CODE_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case REMOVE_PRODUCT_ACTIVATION_CODE_CLEAR:
      state = {
        ...state,
        removed: null,
      };
      break;
    case EXPORT_CSV_PRODUCT_ACTIVATION_CODE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case EXPORT_CSV_PRODUCT_ACTIVATION_CODE_SUCCESS:
      state = {
        ...state,
        csvData: action.payload,
        loading: false,
      };
      break;
    case EXPORT_CSV_PRODUCT_ACTIVATION_CODE_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case EXPORT_CSV_PRODUCT_ACTIVATION_CODE_CLEAR:
      state = {
        ...state,
        csvData: '',
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
